var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AUTH_STATUS, CLOSE_REASONS, CLOSE_STATUS, USER_INTENT, } from "../lib/constants";
import useAccountReferenceId from "../services/savvy/useAccountReferenceId";
import useAppSelector from "./useAppSelector";
import useCloseHandler from "./useCloseHandler";
import useHandleAuthValid from "./useHandleAuthValid";
import { useState } from "react";
import { useUpdateAccountInfoMutation } from "../services/savvy";
export default function useHandlePolicyOnly() {
    var handleAuthValid = useHandleAuthValid();
    var handleClose = useCloseHandler();
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration; }).isSavvyWidget;
    var getAccountReferenceId = useAccountReferenceId().getAccountReferenceId;
    var _a = useAppSelector(function (state) { return state.applicant; }), accountReferenceIdFromState = _a.accountReferenceId, savvyConnectionIdFromState = _a.savvyConnectionId, jornayaLeadId = _a.jornayaLeadId.savvy;
    var authStatus = useAppSelector(function (state) { return state.auth.auto.status; });
    var updateAccountInfo = useUpdateAccountInfoMutation()[0];
    var _b = useState(false), error = _b[0], setError = _b[1];
    if (error) {
        throw new Error("Error while handling policy only: missing account reference ID");
    }
    /**
     * @todo implement useCallback
     */
    return function handlePolicyOnly(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.accountLinked, accountLinked = _c === void 0 ? undefined : _c, _d = _b.savvyConnectionId, savvyConnectionId = _d === void 0 ? savvyConnectionIdFromState : _d, accountReferenceId = _b.accountReferenceId;
        return __awaiter(this, void 0, void 0, function () {
            var nextArID;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        nextArID = accountReferenceId || accountReferenceIdFromState;
                        if (!isSavvyWidget) return [3 /*break*/, 4];
                        if (!savvyConnectionId) return [3 /*break*/, 2];
                        return [4 /*yield*/, getAccountReferenceId({ savvyConnectionId: savvyConnectionId }).unwrap()];
                    case 1:
                        nextArID = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!nextArID) {
                            return [2 /*return*/, setError(true)];
                        }
                        return [4 /*yield*/, updateAccountInfo({
                                accountReferenceId: nextArID,
                                jornayaLeadId: jornayaLeadId,
                            })];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        if (authStatus === AUTH_STATUS.SUCCESS) {
                            handleAuthValid({ savvyConnectionId: savvyConnectionId });
                        }
                        // because our close handler will always have a stale ArID value here, explicitly
                        // attempt to pass the one we just received, defaulting to nothing.
                        handleClose({
                            accountReferenceId: nextArID,
                            reason: CLOSE_REASONS.COMPLETED_CONNECT_FLOW,
                            status: CLOSE_STATUS.completed_connect,
                            userIntent: USER_INTENT.CONTINUE,
                            accountLinked: accountLinked,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
}
